import type { Chain } from '../../../chain';
import { CHAINS_INFO_MAP } from '../../constants';

type ExtractChainFromNormalizedNameParams = {
  normalizedWalletNameWithChain: string;
};

/**
 * Extracts the chain from a normalized wallet name with chain suffix.
 * The chain is appended in lowercase at the end (e.g., "metamaskevm" -> "EVM").
 *
 * @param params.normalizedWalletNameWithChain - The normalized wallet name with chain suffix.
 * @returns The chain if found, undefined otherwise.
 */
export const extractChainFromNormalizedName = ({
  normalizedWalletNameWithChain,
}: ExtractChainFromNormalizedNameParams): Chain | undefined => {
  const lowerName = normalizedWalletNameWithChain.toLowerCase();

  // Get all chain names in lowercase, sorted by length (longest first) to match longest suffix first
  const chainSuffixes = (Object.keys(CHAINS_INFO_MAP) as Chain[])
    .map((chain) => chain.toLowerCase())
    .sort((a, b) => b.length - a.length);

  for (const suffix of chainSuffixes) {
    if (lowerName.endsWith(suffix)) {
      return suffix.toUpperCase() as Chain;
    }
  }

  return undefined;
};
